// extracted by mini-css-extract-plugin
export default {"card-menu":"CardMenu_card-menu__nTx7A","menu-category":"CardMenu_menu-category__8foef","loading":"CardMenu_loading__uIzIN"};